import { render, staticRenderFns } from "./CustomNav.vue?vue&type=template&id=03a6be0a&scoped=true&"
import script from "./CustomNav.vue?vue&type=script&lang=js&"
export * from "./CustomNav.vue?vue&type=script&lang=js&"
import style0 from "./CustomNav.vue?vue&type=style&index=0&id=03a6be0a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a6be0a",
  null
  
)

export default component.exports